/*
 * @Author: Yuan Cong <email: wso2848303@163.com> <tel: 15821618224>
 * @Date: 2020-12-21 10:57:16
 * @LastEditors Cong Yuan wso2848303@163.com
 * @LastEditTime 2025-05-22 10:24:26
 * @Description: 接口错误代码约定
 * @FilePath: \hsylc2021\src\api\codes.js
 */
export default {
  ERR: 'Err',
  PAY_LOOP_CANCEL: 'pay_loop_cancel', // 支付轮询取消
  SUCCESS: 200, // 正常
  AUTH_ERR: 401, // 未授权，可能是请求时未携带jwt token或者token已过期
  ERR_MSG: 4001, // 直接展示错误信息
  SRC_ERR: 4002, // 请求资源不存在
  PARAM_ERR: 4003, // 请求参数校验失败
  REFREASH: 4004, // TOAST提示加刷新页面
  BACKTOAST: 4005, // TOAST提示加返回上一页
  REDIRECTION: 302, // 重定向
  APPLY_PAID: '402-1', // 申请费支付
  TUITION_PAID: '402-2', // 学费支付
  FORBIDDEN: 403,
  OFFER: '403-10', // 未收到offer
  PLACE_DATA: '403-20', // 未公布会场
  PLACE_OPEN: '403-21', // 未开放选会场
  PLACE_RESULT: '403-22', // 未公布会场
  PLACE_BEIJING: '403-23', // 北京会场
  COURSE_CART: '403-30', // 选课未开放
  COURSE_RESULT: '403-31', // 未公布选课结果
  IS_APPLIED: '403-40', // 是否提交了申请表
  TYPE_ERROR: '403-50', //身份不正确
  COMPLETE_INFO: '403-60' // 未完善信息
};
